import { v4 as uuidv4 } from 'uuid';
export class FuseMockApiUtils {
    

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Generate a globally unique id
     */
    static guid(): string {


        return uuidv4();
    }
}
